import {
  CarePlanGetAllResponse,
  CarePlanSearchParams,
  CreateCarePlanRequest,
} from '@quromedical/models';
import { trpc } from 'trpc';

export const carePlanSWRKey = 'trpc/care-plan';

export class CarePlanApi {
  public getCarePlans = async (params: CarePlanSearchParams): Promise<CarePlanGetAllResponse> => {
    return await trpc.client.carePlan.getAll.query(params);
  };

  public createCarePlan = async (params: CreateCarePlanRequest): Promise<void> => {
    await trpc.client.carePlan.create.mutate(params);
  };
}
